let _this;
let searchTimer = null;
let page = 1;
const PER_PAGE = 50;
let pageCount = 1;
export default {
  name: "MessageFoward",
  data() {
    return {
      msgForwardModal: false,
      forwardInfo: {
        items: [],
        ids: []
      },
      receiverType:0, //接收者类型：0用户，1用户组
      userName: "",
      userList: [], // 用户列表
      userGroupList: [], // 用户组列表
      recipientIds: [], // 选择的用户的id
      recipientGroupIds: [], // 选择的用户组的id
      recipients: [], // 选择的用户或用户组详情集合
      checkFlag: false, // 验证
      operationalRoleFlag:false,
      operationalRole:null,
      roleList2: [],
      recipientRoleIds: [],
      roleList: [
        {
            value: 'GSOCC Operator',
            label: 'GSOCC Operator'
        },
        {
            value: 'Approver',
            label: 'Approver'
        },
        {
            value: 'Ground Supervisor',
            label: 'Ground Supervisor'
        },
        {
            value: 'Security Officer ',
            label: 'Security Officer '
        }
    ],
    showRole: true,
    loading: false,
    }
  },
    mounted() {
      if(this.$root.isESOPMode){
        this.$ajax.get('workflow/role/' +  window.g.ESOP_ROLE_SOURCE,{ baseURL: window.g.API_Flow}).then((res)=>{
         if(res.data.success && res.data.data.length > 0){
          let arr = res.data.data;
          this.roleList2 = arr;
         }  
        })
      }
    _this = this;
    eventBus.$on('forwardMsg', (msgId,showRole=true) => {
      page = 1;
      _this.operationalRole = null;
      _this.receiverType = 0;
      _this.userName = "";
      _this.recipients = [];
      _this.recipientIds = [];
      _this.recipientRoleIds = [];
      _this.recipientGroupIds = [];
      _this.forwardInfo.ids = [ msgId ];
      _this.forwardInfo.items = [];
      _this.msgForwardModal = true;
      _this.showRole = showRole
      _this.checkFlag = false;
    });
  },
  beforeDestroy(){
    eventBus.$off('forwardMsg');
  },
  methods: {
    //转发消息
    forwardMessage: function () {
      this.checkFlag = false;
      if(!this.recipients.length){
        this.checkFlag = true;
        return;
      }
      _this.forwardInfo.items = [];
      if(_this.recipientIds.length){
        _this.forwardInfo.items.push({
          recipients: _this.recipients.filter((item)=>{
             return item.recipientType == 0
          }).map((item)=>{
               return {
                id : item.recipientId,
                name : item.recipientName 
               }
          }),
          recipientType: 0
        })
      }
      if(_this.recipientGroupIds.length){
        _this.forwardInfo.items.push({
          recipients: _this.recipients.filter((item)=>{
            return item.recipientType == 1
         }).map((item)=>{
              return {
               id : item.recipientId,
               name : item.recipientName 
              }
         }),
          recipientType: 1
        })
      }
        if(_this.recipientRoleIds.length){
        _this.forwardInfo.items.push({
          recipients: _this.recipients.filter((item)=>{
            return item.recipientType == 2
         }).map((item)=>{
              return {
               id : item.recipientId,
               name : item.recipientName 
              }
         }),
          recipientType: 2
        })
      }
      _this.forwardInfo.operationalRole = this.operationalRole
      this.$ajax.post('IncidentRecord/Forward', this.forwardInfo).then(function (res) {
        if (res.data.success) {
          _this.messageNotice("success");
          _this.msgForwardModal = false;
        } else {
          _this.messageNotice("error", res.data.message);
        }
      })
    },
    /**
     * 选择用户
     * */
    // 搜索用户
    searchUsers:function () {
      $('.receiver-panel').slideDown(300);
      this.userName = "";
      this.receiverType = 0;
      page = 1;
      _this.userList = [];
      _this.userGroupList = [];
      this.searchUsersDetail();
    },
    // 选择接收者类型
    checkReceiverType:function(type){
      _this.receiverType = type;
      _this.userName = "";
      page = 1;
      _this.searchUsersDetail();
    },
    addSearchTask:function(data){
      clearTimeout(searchTimer);
      searchTimer = setTimeout(()=>{
        page = 1;
        _this.searchUsersDetail(data);
      },500)
    },
    // 账号滚动翻页
    handleAccountScroll: function(e){
      let dom = e.target;
      if( dom.scrollTop === dom.scrollHeight - dom.offsetHeight ){
        if( page < pageCount ){
          page++;
          _this.searchUsersDetail(_this.userName, false, true);
        }
      }
    },
    // 账号组滚动翻页
    handleAccountGroupScroll: function(e){
      let dom = e.target;
      if( dom.scrollTop === dom.scrollHeight - dom.offsetHeight ){
        if( page < pageCount ){
          page++;
          _this.searchUsersDetail(_this.userName, false, true);
        }
      }
    },
    // 根据输入关键字获取相关信息的用户
    searchUsersDetail:function(data, isInit, isPageSearch){
      if(isInit || _this.receiverType === 0){
        _this.searchAccounts(data, isPageSearch);
      }
      if(isInit || _this.receiverType === 1){
        _this.searchAccountGroups(data, isPageSearch);

      }
      if(isInit || _this.receiverType === 2){
        _this.searchRoles(data, isPageSearch);

      }
    },
    // 查询账号
    searchAccounts: function(data, isPageSearch){
      _this.loading = !isPageSearch;
      _this.$ajax.post('Accounts/Options', {name:data, enabledPaging:true, page: page, perPage: PER_PAGE, sortType: 0, sortName: 'name'},
      {
        baseURL: window.g.VERIFICATION_ROOT,
        headers: { noLoading: true },
      }).then((res)=>{
        if (res.data.success) {
          pageCount = res.data.data.pageCount;
          let datas = res.data.data.items;
          datas.forEach((item)=>{
            item.checked = false;
          })
          if( isPageSearch ){
            _this.userList = _this.userList.concat( datas );
          }else{
            _this.userList = datas;
          }
        }
        _this.loading = false;
      })
    },
    // 查询账号组
    searchAccountGroups: function(data, isPageSearch){
      _this.loading = !isPageSearch;
      _this.$ajax.post('AccountGroups/PagingOption', {name:data, enabledPaging:true, page: 1, perPage: PER_PAGE, sortType: 0, sortName: 'name'},
      {
        baseURL: window.g.VERIFICATION_ROOT,
        headers: { noLoading: true },
      }).then((res)=>{
        if (res.data.success) {
          pageCount = res.data.data.pageCount;
          let datas = res.data.data.items;
          datas.forEach((item)=>{
            item.checked = false;
          })
          if( isPageSearch ){
            _this.userGroupList = _this.userGroupList.concat( datas );
          }else{
            _this.userGroupList = datas;
          }
        }
        _this.loading = false;
      })
    },
    // 选择Receiver
    selectReceiver:function(user, type){
      let res = _this.recipients.filter((item,index)=>{
        return item.recipientId === user.id && item.recipientType === type;
      })
      if(res && res[0]){
        _this.recipients = _this.recipients.filter((item,index)=>{
          return item.recipientId !== user.id;
        })
        if(type === 0){
          _this.recipientIds = _this.recipientIds.filter((id,index)=>{
            return id !== user.id;
          })
        }else if(type === 1){
          _this.recipientGroupIds = _this.recipientGroupIds.filter((id,index)=>{
            return id !== user.id;
          })
        }else if(type === 2){
          _this.recipientRoleIds = _this.recipientRoleIds.filter((id,index)=>{
            return id !== user.id;
          })
        }
      }else{
        let curInfo = {
          recipientType: type,
          recipientId: user.id,
          recipientName: user.name
        }
        _this.recipients.push( curInfo );
        if(type === 0){
          if(_this.recipientIds.indexOf(user.id) === -1){
            _this.recipientIds.push(user.id);
          }
        }else if(type == 1){
          if(_this.recipientGroupIds.indexOf(user.id) === -1){
            _this.recipientGroupIds.push(user.id);
          }
        }else if(type == 2){
          if(_this.recipientRoleIds.indexOf(user.id) === -1){
            _this.recipientRoleIds.push(user.id);
          }
        }
      }
    },
    // 取消Receiver
    cancelReceiver:function(user){
      _this.recipients = _this.recipients.filter((item,index)=>{
        return item.recipientId !== user.recipientId;
      })
      if(user.recipientType === 0 && _this.recipientIds.indexOf(user.recipientId) > -1){
        _this.recipientIds = _this.recipientIds.filter((itemId,index)=>{
          return itemId !== user.recipientId;
        })
      }
      if(user.recipientType === 1 && _this.recipientGroupIds.indexOf(user.recipientId) > -1){
        _this.recipientGroupIds = _this.recipientGroupIds.filter((itemId,index)=>{
          return itemId !== user.recipientId;
        })
      }
      if(user.recipientType === 2 && _this.recipientRoleIds.indexOf(user.recipientId) > -1){
        _this.recipientRoleIds = _this.recipientRoleIds.filter((itemId,index)=>{
          return itemId !== user.recipientId;
        })
      }
    },
        // Role滚动翻页
    handleRoleScroll: function (e) {
    let dom = e.target;
    if (dom.scrollTop === dom.scrollHeight - dom.offsetHeight) {
      if (this.page < this.pageCount) {
          this.page++;
          this.searchUsersDetail(this.userName, false, true);
      }
    }
    },
    // 查询Role
    searchRoles: function (data, isPageSearch) {
    let page = this.page;
    _this.loading = !isPageSearch;
    this.$ajax.post('Roles/PagingOption', { name: data, enabledPaging: true, page: page, perPage: PER_PAGE, sortName: 'name', sortType: 0 },
        {
            headers: { noLoading: true },
            baseURL: window.g.VERIFICATION_ROOT
        }).then((res) => {
            if (res.data.success) {
                this.pageCount = res.data.data.pageCount;
                let datas = res.data.data.items;
                datas.forEach((item) => {
                    item.checked = false;
                })
                if (isPageSearch) {
                    this.roleList = this.roleList.concat(datas);
                } else {
                    this.roleList = datas;
                }
            }
            _this.loading = false;
        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/messageFoward.js